export const Draft = 0;
export const Exported = 1;